import { render } from "./AgeNaissance.vue?vue&type=template&id=ad0c2f4a"
import script from "./AgeNaissance.vue?vue&type=script&lang=js"
export * from "./AgeNaissance.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__